import {
  Chart,
  BarController,
  BarElement,
  LineController,
  LineElement,
  PointElement,
  PieController,
  ArcElement,
  CategoryScale,
  LinearScale,
  TimeSeriesScale,
  Tooltip,
  Legend,
} from "chart.js"
import {
  CandlestickController,
  CandlestickElement,
  OhlcController,
  OhlcElement,
} from "chartjs-chart-financial"
import "chartjs-adapter-date-fns"

// Register once at module load. Module evaluation is memoised by the bundler,
// so this runs exactly once per page load regardless of how many components
// import it. Registering inside a component (effect or render) causes
// "controller already registered" warnings under StrictMode double-mounts.
Chart.register(
  BarController,
  BarElement,
  LineController,
  LineElement,
  PointElement,
  PieController,
  ArcElement,
  CategoryScale,
  LinearScale,
  TimeSeriesScale,
  Tooltip,
  Legend,
  CandlestickController,
  CandlestickElement,
  OhlcController,
  OhlcElement
)
